import React, { Component } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import "./FailedReportsEmailModal.css";

class FailedReportsEmailModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { emailFailed, toggleFailedReportsEmailModal } = this.props;

    return (
      <SweetAlert
        customClass="FailedReportsEmailModal__SweetAlert"
        title=""
        showConfirm={false}
        onConfirm={() => {}}
        // onCancel={() => toggleFailedReportsEmailModal()}
      >
        <div className="FailedReportsEmailModal__Header">
          {emailFailed.length > 0
            ? "Emails failed for the following reports"
            : "Documents Sent Successfully!"}
        </div>

        {emailFailed.length > 0 && (
          <table className="FailedReportsEmailModal__Table">
            <thead className="FailedReportsEmailModal__Table__Thead">
              <tr>
                <th className="customTh FailedReportsEmailModal__Table__Th">
                  #
                </th>
                <th className="customTh FailedReportsEmailModal__Table__Th">
                  ID
                </th>
                <th className="customTh FailedReportsEmailModal__Table__Th">
                  File
                </th>
              </tr>
            </thead>
            <tbody>
              {emailFailed.map((item, i) => (
                <tr key={i}>
                  <td className="FailedReportsEmailModal__Table__Td">
                    {" "}
                    {i + 1}
                    {" "}
                  </td>
                  <td className="FailedReportsEmailModal__Table__Td">

                    {item.order_id}
                  </td>
                  <td className="FailedReportsEmailModal__Table__Td">

                    {item.s3_url}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        <div>
          <button
            type="button"
            className="FailedReportsEmailModal__CloseBtn"
            onClick={() => toggleFailedReportsEmailModal()}
          >
            Close
          </button>
        </div>

      </SweetAlert>
    );
  }
}

export default FailedReportsEmailModal;
